
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Control background","fill":"rgba(0,0,0,0)","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M19 21H5V3h9.384l.216.194 4.2 4.154.2.216V21zM6.4 4.384v15.232h11.2V8.539h-4.2V4.384zm8.4 1v1.77h1.794zm.7 11.467h-7v-1.39h7v1.384zm0-2.769h-7v-1.39h7v1.384zm0-2.769h-7v-1.39h7v1.384z","fill":"currentColor","data-name":"Icons – 24px / Document"}})])
          )
        }
      }
    